"use client";

import { FooterVisibilityProvider } from "@/context/FooterVisibilityProvider";
import { HeaderActionsProvider } from "@/context/HeaderActionsProvider";
import { UserProvider } from "@/context/UserProvider";
import { Toaster } from "react-hot-toast";
import ServiceWorkerRegistration from "@/components/pwa/ServiceWorkerRegistration";

export default function Providers({ children }: { children: React.ReactNode }) {
	return (
		<UserProvider>
			<HeaderActionsProvider>
				<FooterVisibilityProvider>
					{children}
					<Toaster position="bottom-left" />
					<ServiceWorkerRegistration />
				</FooterVisibilityProvider>
			</HeaderActionsProvider>
		</UserProvider>
	);
}
